<section class="product-comparison-section">
    <div class="container">
        <!-- Section Header -->
        <div class="section-header text-center">
            <h2 class="section-title">Product <span>Comparison</span></h2>
            <div class="title-underline"></div>
            <p class="section-description">Explore our comprehensive product lineup</p>
        </div>

        <!-- Cards Container -->
        <div class="cards-wrapper">
            <div class="cards-container" #cardsContainer>
                <div class="product-card" *ngFor="let slide of slides; let i = index">
                    <!-- Icon/Image Section -->
                    <div class="card-image">
                        <mat-icon class="card-icon">{{ slide.icon }}</mat-icon>
                    </div>

                    <!-- Card Content -->
                    <div class="card-content">
                        <h3 class="card-title">{{ slide.title }}</h3>
                        <p class="card-subtitle" *ngIf="slide.subtitle">{{ slide.subtitle }}</p>

                        <!-- Features List -->
                        <ul class="features-list">
                            <li class="feature-item" *ngFor="let feature of slide.features">
                                <span class="feature-name">{{ feature.name }}</span>
                                <span class="feature-value" *ngIf="feature.value">{{ feature.value }}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>

            <!-- Navigation Arrows -->
            <button class="nav-arrow prev" (click)="scrollLeft()" aria-label="Previous">
                <mat-icon>chevron_left</mat-icon>
            </button>
            <button class="nav-arrow next" (click)="scrollRight()" aria-label="Next">
                <mat-icon>chevron_right</mat-icon>
            </button>
        </div>

        <!-- Pagination Dots -->
        <div class="pagination">
            <span *ngFor="let slide of slides; let i = index" class="dot" [class.active]="i === currentSlideIndex"
                (click)="goToSlide(i)">
            </span>
        </div>
    </div>
</section>